import _ from 'lodash';
import moment from 'moment';
import OPERATORS from '../constants/operators';
import DATE_FORMATS from '../constants/dateFormats';

const operatorMap = {
  [OPERATORS.EQUALS]: (value, from) => moment(value).isSame(from),
  [OPERATORS.GREATER_THAN]: (value, from) => moment(value).isAfter(from),
  [OPERATORS.GREATER_THAN_EQUAL_TO]: (value, from) => moment(value).isSameOrAfter(from),
  [OPERATORS.SMALLER_THAN]: (value, from) => moment(value).isBefore(from),
  [OPERATORS.SMALLER_THAN_EQUAL_TO]: (value, from) => moment(value).isSameOrBefore(from),
  [OPERATORS.BETWEEN]: (value, from, to) => moment(value).isBetween(moment(from), moment(to)),
};

const freeTextSearch = (rowValue, operator, fromDate, toDate) =>
  !operatorMap[operator] || operatorMap[operator](rowValue, fromDate, toDate);

const dateFilterMethod = (filter, row) => {
  const {
    operator,
    fromDate,
    toDate,
    clearFilter,
    multiSelectValues,
  } = filter.value;

  if (clearFilter) {
    return true;
  }

  const rowValue = row[filter.id];
  const isRowValueArray = Array.isArray(rowValue);

  if (multiSelectValues && multiSelectValues.length) {
    if (isRowValueArray) {
      return !!_.find(multiSelectValues, multiSelectValue =>
        rowValue.map(v => moment(v).format(DATE_FORMATS.date))
          .indexOf(multiSelectValue.value) > -1);
    }

    return !!_.find(multiSelectValues, {
      value: rowValue ? moment(rowValue).format(DATE_FORMATS.date) : null,
    });
  }

  if (isRowValueArray) {
    return !!rowValue.find(value => freeTextSearch(value, operator, fromDate, toDate));
  }

  return freeTextSearch(rowValue, operator, fromDate, toDate);
};

export default dateFilterMethod;
